import React, { type PropsWithChildren, useMemo } from 'react'
import { Navigate, useLocation } from 'react-router-dom'

import { Loader } from '@UI/Loader'

import { useAppSelector } from '@store/hooks'
import { useGetInfoAbutMeQuery } from '@store/profile/profile.api'

export function RequireAuth({ children }: PropsWithChildren) {
  const location = useLocation()

  const { isAuth } = useAppSelector((state) => state.auth)

  const { data: aboutMe, isLoading } = useGetInfoAbutMeQuery({})

  const navigateTo = useMemo(() => {
    if (!aboutMe) return

    const { status, role } = aboutMe

    if ([1, 2].includes(status)) {
      if (role === 10 && location.pathname !== '/sign-up/parents' && location.pathname !== '/sign-up/children') return '/sign-up/parents'
      if (role === 20) return '/sign-up/teacher'
    }
    if ([3, 4].includes(status)) return '/moderating'
    if (status === 5) return '/success'
    if (status === 6 && location.pathname === '/success') return '/'
  }, [aboutMe])

  if (!isAuth) {
    return (
      <Navigate
        to="/auth/sign-in"
        replace={true}
      />
    )
  }

  if (isLoading) return <Loader />

  if (navigateTo && location.pathname !== navigateTo) {
    return (
      <Navigate
        to={navigateTo}
        replace={true}
      />
    )
  }

  return <>{children}</>
}
